(function() {
  'use strict';

  angular.module('eclipseApp.checkout').factory('buySession', [
    '$localStorage',
    '$log',
    function($localStorage, $log) {
      var identifiers = {
        prefix: 'FC_',
        serviceableAddress: 'SERV_ADDR'
      };

      var buySession = {
        setCheckoutSessionObj: function(name, data) {
          var _obj = {},
            _name = identifiers.prefix.concat(name);
          _obj[_name] = data;

          console.log('@buySession: setCheckoutSessionObj( @param ): unknown keyId', name, data);
          return _obj;
        },
        getCheckoutSessionKey: function(name) {
          return identifiers.prefix.concat(name);
        },
        getKeyId: function(keyId, customKey) {
          var _id;
          if (keyId && keyId in identifiers) {
            if (customKey) {
              _id = identifiers[keyId].concat('_' + customKey);
              return _id;
            } else {
              return identifiers[keyId];
            }
          } else {
            $log.warning('@buySession: getKeyId( @param ): unknown keyId');
          }
        }
      };

      return buySession;
    }
  ]);
})();
